import { useQuery } from '@tanstack/react-query';
import { getUserPreferences, Form30UserPreferencesResponse } from '../../services/network/form30UserPreferences-api';

export const useFetchForm30UserPreferences = () => {
    const { data, isLoading, isError, error, refetch } = useQuery<Form30UserPreferencesResponse>({
        queryKey: ['form30UserPreferences'],
        queryFn: async () => {
            return await getUserPreferences();
        },
        staleTime: 5 * 60 * 1000,
        retry: 2,
    });

    return {
        userPreferences: data?.data || null,
        isLoading,
        isError,
        error,
        refetch
    };
};
